import React from "react";
import {Button, Typography} from "@material-ui/core";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import Styles from "../Common/style.module.css";
import {Wrapper} from "./useStyles";

const PackageUpdateSuccess = ({ onCloseCallback }) => {
    return(
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Wrapper>
                        <div>
                            <div className={'iconWrapper'}>
                                <img src={`${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/approved_4053006.png`} alt={'success'}/>
                            </div>
                            <Typography className={'title'}>Success!</Typography>
                            <Typography variant="body1" className={'contentText'}>
                                Your plan has been upgraded.<br />
                                It may take a few minutes for the system to process the update.
                            </Typography>
                        </div>
                        <div className={'actions'}>
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    onClose();
                                    onCloseCallback();
                                }}
                                className={'closeButton'}
                            >
                                Close
                            </Button>
                        </div>
                    </Wrapper>
                );
            },
            closeOnClickOutside: false,
            overlayClassName: Styles.overlay
        })
    );
};

export default PackageUpdateSuccess;